import { useCompStore } from '../components/store';

export const getParcelAdjustments = (parcelId) => {
  const adjustments = useCompStore.getState().adjustments;
  if (!adjustments || !parcelId || !adjustments.countycode) return adjustments || {};
  const countyCodes = Array.isArray(adjustments.countycode) ? adjustments.countycode : [adjustments.countycode];
  const parcelPrefix = String(parcelId).slice(0, 5);
  const index = countyCodes.findIndex((code) => String(code) === parcelPrefix);
  if (index < 0) return adjustments || {};
  return Object.keys(adjustments).reduce((acc, key) => {
    if (key === 'countycode') return acc;
    const value = adjustments[key];
    acc[key] = Array.isArray(value) ? value[index] : value;
    return acc;
  }, {});
};
